<template>
    <el-dialog center title="微课堂" :visible.sync="dialogFormVisibleMicro" size="small"  width="50%"  :before-close="handleDialogConfigureShow" :close-on-click-modal=false :close-on-press-escape=false >
        <el-table :data="form.stage_subjects_bind" border>
            <el-table-column  label="学段" width="180">
                <template slot-scope="scope">
                    <el-checkbox v-model="scope.row.checkAll"  @change="handleCheckAllChange(scope.row.stage_id)">{{scope.row.stage_name}}</el-checkbox>
                </template>
            </el-table-column>
            <el-table-column label="学科" width="729">
                <template slot-scope="scope">
                    <el-checkbox-group v-model="scope.row.checked" @change="handleCheckedSubjectChange(scope.row.stage_id)" >
                        <el-checkbox v-for="subject in scope.row.subjects" :label="subject" :key="subject">{{subject}}</el-checkbox>
                    </el-checkbox-group>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer" >
            <el-button type=primary @click="handleDialogConfigureShow">确定</el-button>
        </div>
    </el-dialog>
</template>

<style scoped>
    .app-main .main-bd .el-row {
        padding: 10px 0;
    }
</style>
<script>
import CommonService from "~/services/common";

export default {
    components:{
        CommonService
    },

    props:{
            params:{
                type:Object,
                required:false
            }
    },
    data() {
        return {
            form:{
                product_id:'',
                stage_subjects_bind: [
                    {   
                        stage_id:1,
                        stage_name:'小学',
                        subjects:['语文','数学','英语','历史'],
                        checkAll:false,
                        checked:[]
                    },
                    {   
                        stage_id:2,
                        stage_name:'初中',
                        subjects:['语文','数学','英语','化学'],
                        checkAll:false,
                        checked:[]
                    },
                    {   
                        stage_id:3,
                        stage_name:'高中',
                        subjects:['语文','数学','英语','政治'],
                        checkAll:false,
                        checked:[]
                    }
                ]
            },
            activeIndex:'0',
            formLabelWidth:'120px',       
        };
    },
    props:{
            dialogFormVisibleMicro:{
                default:false
            },
            params:{
                type:Object,
                required:true
            }
    },
    mounted() {
        this.form = Object.assign(this.form,this.params.config);
        this.form.product_id = this.params.id;
    },
    methods:{
        handleDialogConfigureShow(){
            this.$emit('handleDialogConfigureShow',this.form);
        },

        /**
         * 全选
         */
        handleCheckAllChange(val) {
            let index = val - 1;
            if(this.form.stage_subjects_bind[index].checkAll == ''){
                this.form.stage_subjects_bind[index].checkAll = false;
                this.form.stage_subjects_bind[index].checked = [];
            }else{
                this.form.stage_subjects_bind[index].checkAll = true;
                this.form.stage_subjects_bind[index].checked = this.form.stage_subjects_bind[index].subjects;
            }
        },
        handleCheckedSubjectChange(value){
            let index = value - 1; 
            let checked = this.form.stage_subjects_bind[index].checked.length;
            let Count = this.form.stage_subjects_bind[index].subjects.length;
            if(Count>checked){
                this.form.stage_subjects_bind[index].checkAll = false;
            }else{
                this.form.stage_subjects_bind[index].checkAll = true;
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/views/order/microClassConfigure.vue